import { ChromeTokens } from './tokens';

export interface PillButtonProps {
  size: 'sm' | 'md' | 'lg';
  tone: 'primary' | 'subtle';
  disabled?: boolean;
  ariaLabel: string;
  onClick: () => void;
  onFocus?: () => void;
  children: React.ReactNode;
}

const sizes = {
  sm: { padding: '6px 12px', fontSize: 13 },
  md: { padding: '10px 18px', fontSize: 15 },
  lg: { padding: '14px 24px', fontSize: 17 },
};

export function PillButton({ size, tone, disabled, ariaLabel, onClick, onFocus, children }: PillButtonProps) {
  return (
    <button
      aria-label={ariaLabel}
      disabled={disabled}
      onClick={onClick}
      onFocus={onFocus}
      style={{
        ...sizes[size],
        borderRadius: ChromeTokens.radius.pill,
        border: 'none',
        cursor: disabled ? 'not-allowed' : 'pointer',
        background: tone === 'primary' ? ChromeTokens.color.sun : ChromeTokens.color.baseMuted,
        color: ChromeTokens.color.ink,
        boxShadow: ChromeTokens.shadow.soft,
        fontWeight: 600,
        transition: `transform ${ChromeTokens.motion.pop}`,
        opacity: disabled ? 0.5 : 1,
        minHeight: 44,
      }}
    >
      {children}
    </button>
  );
}
